import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SKYC_FORM_TYPE } from './SkycFormWidgetPropTypes';
import { AadhaarVerification, MobileNumberVerification, AadhaarConfirmation, PhotoVideoVerification, IncomeDetailsVerification, DisabilityInformation, IdentityProof, SimDeclaration, AddressWidget, SimPortDetails, NumberSelection } from './components';
export var SkycFormWidgetComponent = props => {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? SKYC_FORM_TYPE.MOBILE_NUMBER_VERIFICATION : _props$variant;
  var renderForm = () => {
    switch (variant) {
      case SKYC_FORM_TYPE.MOBILE_NUMBER_VERIFICATION:
        return _jsx(MobileNumberVerification, Object.assign({}, props));
      case SKYC_FORM_TYPE.AADHAAR_VERIFICATION:
        return _jsx(AadhaarVerification, Object.assign({}, props));
      case SKYC_FORM_TYPE.SIM_DECLARATION:
        return _jsx(SimDeclaration, Object.assign({}, props));
      case SKYC_FORM_TYPE.PHOTO_VERIFICATION:
      case SKYC_FORM_TYPE.VIDEO_VERIFICATION:
        return _jsx(PhotoVideoVerification, Object.assign({}, props));
      case SKYC_FORM_TYPE.INCOME_DETAILS_VERIFICATION:
        return _jsx(IncomeDetailsVerification, Object.assign({}, props));
      case SKYC_FORM_TYPE.IDENTITY_PROOF:
        return _jsx(IdentityProof, Object.assign({}, props));
      case SKYC_FORM_TYPE.DISABILITY_INFO:
        return _jsx(DisabilityInformation, Object.assign({}, props));
      case SKYC_FORM_TYPE.CURRENT_ADDRESS_DETAILS:
      case SKYC_FORM_TYPE.LOCAL_REFERENCE_DETAILS:
        return _jsx(AddressWidget, Object.assign({}, props));
      case SKYC_FORM_TYPE.AADHAAR_DETAILS:
        return _jsx(AadhaarConfirmation, Object.assign({}, props));
      case SKYC_FORM_TYPE.SIM_PORT_DETAILS:
        return _jsx(SimPortDetails, Object.assign({}, props));
      case SKYC_FORM_TYPE.NUMBER_SELECTION:
        return _jsx(NumberSelection, Object.assign({}, props));
      default:
        return _jsx(_Fragment, {});
    }
  };
  return _jsx(_Fragment, {
    children: renderForm()
  });
};
SkycFormWidgetComponent.genericRendererKey = 'AirSkycFormWidget';